export const NO_IMAGE = `/assets/images/no-image.png`;


export const APP_MODE = 'ORDER_MODE'; // 'ORDER_MODE' OR 'SALES_MODE'

export const API_MIGO_TOKEN = "DUGTbjslOBwTVtdz1ZGQlCwi3SqSqaYX0egcTmWhPdlR9sct1RM5pvpQ5ar7";
export const API_MIGO_DNI = "https://api.migo.pe/api/v1/dni";
export const API_MIGO_RUC = "https://api.migo.pe/api/v1/ruc";

export const PRODUCTION = 'production';
export const DEVELOPMENT = 'development';
export const TESTING = 'testing';
export const STAGING = 'staging';
export const STAGING2 = 'staging2';
export const STAGING3 = 'staging3';